import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {createPulseRoute} from '@github-ui/repos-pulse-page/routes/create-pulse-route'
import {reposPulseAppBuilder} from './config/app-builder'

export const reposPulseApp = reposPulseAppBuilder.createDataRouterAppFromRoutes([
  createPulseRoute(reposPulseAppBuilder),
])
registerDataRouterApp(reposPulseApp)
